import { QUEUE_BEING_DELIVERED } from '../constants/status';

const beingDeliveredOrders = ({ currentTicket }) => currentTicket.queue === QUEUE_BEING_DELIVERED;
const getBeingDeliveredOrders = orders => orders.filter(beingDeliveredOrders);

export default getBeingDeliveredOrders;



// WEBPACK FOOTER //
// ../utils/selectors/being-delivered-orders.js